import React, { useState, useMemo } from 'react';
import { Grid } from '@material-ui/core';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../../internal/ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import ReactDOM from 'react-dom';
import DialogComp from '../../../../Core/Modal/dialogModal';
import AddUpdateWorkshopShifts from './addUpdateWorkshopShifts';

const styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Workshop Shifts', path: '/', active: true }
];

const WorkshopShifts = () => {
    const [state, setState] = useState({
        isReload: new Date(),
        showModal: false,
        selectedShiftID: null,
        selectedRow: null
    });

    const handleClose = (shouldReload) => {
        setState((st) => ({
            ...st,
            showModal: false,
            selectedShiftID: null,
            selectedRow: null,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };

    const baseColumns = [
        {
            field: 'action',
            title: `Action`,
            filterable: false,
            sortable: false,
            width: '2%'
        },
        {
            field: 'name',
            title: `Shift Name`,
            filterable: true,
            sortable: true,
            width: '15%'
        },
        {
            field: 'startTime',
            title: `Start Time`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'endTime',
            title: `End Time`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'displaySequence',
            title: `Display Sequence`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'isActive',
            title: `Active?`,
            filterable: true,
            sortable: true,
            width: '8%',
            renderer: (val) => (val === 'Yes' || val === true || val === 'true' ? 'Yes' : 'No')
        }
    ];

    const handleAddUpdate = (row = null) => {
        setState((st) => ({
            ...st,
            showModal: true,
            selectedShiftID: row ? (row.shiftID || row.id || null) : null,
            selectedRow: row || null
        }));
    };

    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justify="center" style={{ marginLeft: '5px' }}>
                <abbr title="Add Workshop Shift">
                    <SquareButton style={styleObj} onClick={() => handleAddUpdate(null)}>
                        <Add fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = () => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justify="space-evenly">
                <abbr title="Edit Workshop Shift">
                    <SquareButton style={styleObj} onClick={() => handleAddUpdate(record)}>
                        <EditIcon fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');
        if (actionCol) {
            actionCol.renderer = editButton();
        }
        return tempCols;
    }, []);

    const baseUrl = 'WorkshopShifts/WorkshopShiftsList';

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data?.table || res?.data?.list || [],
                            total: res?.data?.table?.[0]?.total || res?.data?.list?.[0]?.total || res?.data?.table?.length || 0
                        })}
                        columns={columns}
                        getUrl={baseUrl}
                        isReload={state.isReload}
                        AddBtn={addButton}
                        setRowStyleOnCondition={true}
                        setRowStyleFunction={(record) => ({
                            'background-color': record.backgroundColour || record.bgColour || '#ffffff',
                            color: record.textColour || record.txtColour || '#000000'
                        })}
                    />
                </Grid>
            </Grid>
            {state.showModal ? (
                <DialogComp
                    maxWidth="sm"
                    PaperProps={{ style: { minHeight: '350px', minWidth: '600px' } }}
                    title={state.selectedShiftID ? 'Update Workshop Shift' : 'Add Workshop Shift'}
                    onClose={() => handleClose(false)}
                >
                    <AddUpdateWorkshopShifts
                        onClose={() => handleClose(true)}
                        shiftID={state.selectedShiftID}
                        rowData={state.selectedRow}
                    />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default WorkshopShifts;
